
  
<script>
import Layout from "../../layouts/main";
import CampaignApi from "@/services/campaign-api";
import Swal from "sweetalert2";

export default {
    name: 'planification',
    components: {Layout},

    props:{
     campaignId :{
            type:Number,
            default: null
        },
    },
    data() {
      return {
        planningDelivery:null,
        planningDistributionDelivery:{date: null , percent:null},
        planningDeliveryDates:[],

        validationMsg: null,
        carrierModes:null,
        selectedCarrierModes:null

      };
    },

    mounted() {
        if(this.campaignId){
            this.planningDeliveryBag()
        }
       /* this.findCarrierDeliveryModes()*/
    },

    methods: {
      /*  findCarrierDeliveryModes(){
            CampaignApi.findCarrierDeliveryModes().then(result => {
                if(result){
                    this.carrierModes = result
                }
            })
        },*/

        savePlanningDelivery(){

            const planningDeliveryRequest = {
                campaignId: this.campaignId ,
                isFairDistribution: this.planningDelivery.isFairDistribution,
                planningDeliveryByCities: this.planningDelivery.cityDTOS == null ? null :this.planningDelivery.cityDTOS ,
                planningDeliveryDates : this.planningDeliveryDates,
                // carrierDeliveryModeId: this.selectedCarrierModes == null ? null : this.selectedCarrierModes.id
            }


            Swal.fire({
            title: "Êtes-vous sûr de vouloir créer les commandes des livraisons selon cette planification ?",   
            icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#d11010",
              confirmButtonText: "Oui, créer",
              cancelButtonText: "Annuler",
            }).then((result) => {
              if (result.value) {
               
                CampaignApi.savePlanningDelivery(planningDeliveryRequest).then(result => {
                if(result){
                    this.$router.push({ path: '/campaign/etat', query: { campaignId: this.campaignId } })
                }
            })
              }
            });

           
        },

        planningDeliveryBag(){
            CampaignApi.planningDeliveryBag(this.campaignId).then(result=>{
                if(result){
                    this.planningDelivery = result
                }
            })
        },

         addPlanningDeliveryDate(){

            this.validationMsg = null;

            if( this.lastPercent <= 0 ){
                this.validationMsg = "La somme des pourcentages des livraisons ne doit pas dépasser 100%";
                return
            }

            if(!this.planningDistributionDelivery || !this.planningDistributionDelivery.date  ){
                this.validationMsg = "La date de livraison est obligatoire";
                return
            }

            if(this.planningDistributionDelivery && !this.planningDistributionDelivery.percent ){
                this.planningDistributionDelivery.percent = this.lastPercent
            }

            this.planningDeliveryDates.push(this.planningDistributionDelivery)
            this.planningDistributionDelivery= {date: null , percent:null}
        } ,

        removePlanningDeliveryDate(index){
            this.planningDeliveryDates.splice(index, 1);
        },

    },
    computed: {
        lastPercent() {
            return 100- this.planningDeliveryDates.reduce((sum, delivery) => {
                // Ensure delivery.percent is treated as a number, default to 0 if it's invalid
                const percent = parseFloat(delivery.percent);
                return sum + (isNaN(percent) ? 0 : percent);
            }, 0);
        }
    }

  };
  </script>

<template>
    <Layout>

        <div v-if="planningDelivery" class=" border-0 rounded-3  mr-sm-5 ml-sm-5">
            <div class="row p-md-0 p-2">
                <div class="col-md-6 col-12 ">
                    <h1 class="text-primary text-uppercase font-weight-bold">{{ planningDelivery.campaignName	 }}
                    </h1>

                    <h5 class="text-dark font-weight-bold text-uppercase font-size-20">
                        {{ planningDelivery.customerName }}
                    </h5>

                </div>

                <div class="col-md-6 col-12 text-center mt-md-0 mt-3">
                    <h2 class="text-white text-uppercase font-weight-bold font-size-16 p-2 bg-warning" 
                        style="border-radius: 6px; letter-spacing: 2px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);"> 
                        {{ $t('campaign.deliveryPlanning') }} <strong class="mr-1 ml-1 font-size-20">{{planningDelivery.quantityBagAsString}}</strong> {{ $t('campaign.bags') }}
                    </h2>    </div>
            </div>
        </div>

      

        <div class="card mr-sm-5 ml-sm-5 mt-4" style="border: 1px solid rgb(221, 221, 221);"    >
            <div v-if="planningDelivery" class="row pr-4 pl-4 pt-4 pb-5">

            <div class="col-md-4 col-12">

                <h2 class="card-title font-size-25 text-dark text-uppercase mb-5" style="font-size:25px;"> 1. {{ $t('campaign.delivery.distributionBags') }} </h2>

                <div class="mt-3">
                    <b-form-checkbox 
                        :value="true"  
                        :unchecked-value="false" 
                        v-model="planningDelivery.isFairDistribution" 
                        class="custom-checkbox custom-checkbox-success font-size-16">
                        <label :class="planningDelivery.isFairDistribution ? 'text-primary' : 'text-muted'" class="font-size-16">
                            {{ $t('campaign.delivery.isFairDistribution') }}
                        </label>
                    </b-form-checkbox>

                </div>

                <div class="mt-2">
                <div v-for="cityDTOS in planningDelivery.cityDTOS" :key="cityDTOS.id" 
                    :style="planningDelivery.isFairDistribution ? 'opacity: 0.5;' : 'opacity: 1;'"
                    class="row mt-4 text-left">

                    <div class="col-md-2 col-6">
                        <span class="text-truncate text-dark font-size-16" >{{ cityDTOS.name }}</span>
                    </div>        

                    <div class="col-md-10 col-6">


                        <div class="input-group ">
                            <b-form-input
                            v-model="cityDTOS.percent"
                            type="number"
                            :disabled="planningDelivery.isFairDistribution"
                            class="w-100 text-right font-size-14 text-primary font-weight-bold"
                            style="max-width: 100px;"></b-form-input>                            
                        <div class="input-group-append">
                                <span class="input-group-text text-dark font-weight-bold">%</span>
                            </div>
                        </div>


                        
                    </div>
                </div>
            </div>

            
            </div>

            <div class="col-1 d-md-block d-none">
                <img alt="Next Step" width="30px" src="@/assets/icons/next.svg" />
            </div>

            <div class="col-md-5 col-12 mt-md-0 mt-4">
            

                <div class=" col-12 ">


                        <h2 class="card-title font-size-25  mb-5 text-dark text-uppercase" style="font-size:25px;">
                            2. {{ $t('campaign.delivery.settings') }}
                        </h2>

                       
                        <div>
                            <b-alert v-if="validationMsg" show  variant="danger" class="mt-3" dismissible> {{ validationMsg }}</b-alert>
                        </div>

                        <div v-if="this.planningDeliveryDates">
                        <div v-for="(planningDeliveryDate , index) in this.planningDeliveryDates" :key="index">


                        <div class="mt-4">
                        <div class="row">
                            <div class="col-12 col-sm-2 text-left text-dark font-weight-bold font-size-16">
                                {{ $t('campaign.delivery.delivery') }} {{ index +1 }}
                            </div>

                            <div class="col-12 col-sm-4 text-left pr-2" >
                                
                                <b-form-datepicker
                                style="max-width: 250px;"
                                    v-model="planningDeliveryDate.date"
                                    :locale="$t('datPicker.locale')"
                                    :label-no-date-selected="$t('datPicker.delivery.label-no-date-selected')"
                                    dark
                                    reset-button
                                    close-button
                                    :label-reset-button="$t('datPicker.label-reset-button')"
                                    :label-close-button="$t('datPicker.label-close-button')"
                                    dropright
                                    hide-header
                            ></b-form-datepicker>
                            </div>

                            <div class="col-12 col-sm-4 mb-3 mb-sm-0  mt-md-0 mt-2 text-center">
                                



                                <div class="input-group ">
                                    <b-form-input
                                    v-model="planningDeliveryDate.percent"
                                    type="number"
                                    class="w-100 font-size-14 text-primary font-weight-bold text-right"
                                    style="max-width: 100px;"
                                ></b-form-input>                         
                                                <div class="input-group-append">
                                                        <span class="input-group-text text-dark font-weight-bold">%</span>
                                                    </div>
                                                </div>


                            </div>

                            <div class="col-12 col-sm-2 text-left">
                                <img alt="Edit" width="30px" src="@/assets/icons/minus-circle.svg" style="cursor: pointer;" @click="removePlanningDeliveryDate(index)" />
                            </div>
                        </div>
                        </div>
                        </div>
                        </div>

                        <div v-if="this.lastPercent > 0" class="mt-4">
                            <div class="row d-flex  align-items-center">
                                <div class="col-md-2 col-4  text-left text-dark font-weight-bold font-size-16">
                                    {{ $t('campaign.delivery.delivery') }} {{ planningDeliveryDates.length +1 }}
                                </div>

                                <div class="col-md-4 col-8  text-left pr-2" >

                                <b-form-datepicker
                                style="max-width: 250px;"
                                    v-model="planningDistributionDelivery.date"
                                    :locale="$t('datPicker.locale')"
                                    :label-no-date-selected="$t('datPicker.delivery.label-no-date-selected')"
                                    dark
                                    reset-button
                                    close-button
                                    :label-reset-button="$t('datPicker.label-reset-button')"
                                    :label-close-button="$t('datPicker.label-close-button')"
                                    dropright
                                    hide-header
                                ></b-form-datepicker>
                                </div>

                                <div class="col-md-4 col-6  mb-3 mb-sm-0 mt-md-0 mt-2 text-md-center">
                                    <div class="input-group ">
                                        <b-form-input
                                            v-model="planningDistributionDelivery.percent"
                                            type="number"
                                            class="w-100 text-right font-size-14 text-primary font-weight-bold"
                                            :placeholder="lastPercent.toString()"
                                            style="max-width: 100px;"
                                        ></b-form-input>                       
                                        <div class="input-group-append">
                                            <span class="input-group-text text-dark font-weight-bold">%</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2 col-6  text-left">
                                    <img alt="Edit" width="30px" src="@/assets/icons/add-circle.svg" style="cursor: pointer;" @click="addPlanningDeliveryDate()" />
                                </div>
                            
                            </div>
                        </div>


                        </div>
            </div>

            <div class="col-md-1 d-md-block d-none">
                <img alt="Next Step" width="30px" src="@/assets/icons/next.svg" />
            </div>

            <div class="col-md-1 col-12">
                <b-button variant="primary" @click="savePlanningDelivery()" class="float-sm-right mt-2 mt-lg-0 mt-xl-0 mt-md-0 text-uppercase font-weight-bold" >
                {{ $t('buttons.validate') }}
            </b-button>
            </div>

        </div>

        <!-- <div class="row pr-4 pl-4 pt-4 pb-5">
                <div class="col-5">
                    <div class=" col-12 ">


                        <h2 class="card-title font-size-25  mb-5 text-dark text-uppercase" style="font-size:25px;">
                            3. {{ $t('campaign.delivery.carrierMode') }}
                        </h2>

                        <div class="col-md-6 pr-2 pt-2 pt-md-0">
                            <b-form-group label="" label-for="">
                                <v-select :options="carrierModes" :placeholder="$t('lists.carrier.label')" label="name" v-model="selectedCarrierModes">
                                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                                </v-select>
                            </b-form-group>
                        </div>



                    </div>
                </div>
                <div class="col-1">
                    <img alt="Next Step" width="30px" src="@/assets/icons/next.svg" />
                </div>
            </div> -->

    </div>

    </Layout>
</template>
